
import React from 'react';

export const LoadingVertText = (props) => {

  var {letterColor} = props

  return <div className='loading-v-text'>
           <div style={ { color: letterColor } } className='jitsu-loading-span'>
             L
           </div>
           <div className='v-space-1'></div>
           <div style={ { color: letterColor } } className='jitsu-loading-span'>
             o
           </div>
           <div className='v-space-1'></div>
           <div style={ { color: letterColor } } className='jitsu-loading-span'>
             a
           </div>
           <div className='v-space-1'></div>
           <div style={ { color: letterColor } } className='jitsu-loading-span'>
             d
           </div>
           <div className='v-space-1'></div>
           <div style={ { color: letterColor } } className='jitsu-loading-span'>
             i
           </div>
           <div className='v-space-1'></div>
           <div style={ { color: letterColor } } className='jitsu-loading-span'>
             n
           </div>
           <div className='v-space-1'></div>
           <div style={ { color: letterColor } } className='jitsu-loading-span'>
             g
           </div>
         </div>
}


export const LoadingVertLeftText = (props) => {

  var {letterColor} = props

  return <div className='loading-v-left'>
           <div style={ { color: letterColor } } className='jitsu-loading-span'>
             j
           </div>
           <div className='v-space-1'></div>
           <div style={ { color: letterColor } } className='jitsu-loading-span'>
             i
           </div>
           <div className='v-space-1'></div>
           <div style={ { color: letterColor } } className='jitsu-loading-span'>
             t
           </div>
           <div className='v-space-1'></div>
           <div style={ { color: letterColor } } className='jitsu-loading-span'>
             s
           </div>
           <div className='v-space-1'></div>
           <div style={ { color: letterColor } } className='jitsu-loading-span'>
             u
           </div>
         </div>
}



export const LoadingVertRightText = (props) => {

  var {letterColor} = props

  return <div className='loading-v-right'>
           <div style={ { color: letterColor } } className='jitsu-loading-span'>
             c
           </div>
           <div className='v-space-1'></div>
           <div style={ { color: letterColor } } className='jitsu-loading-span'>
             h
           </div>
           <div className='v-space-1'></div>
           <div style={ { color: letterColor } } className='jitsu-loading-span'>
             a
           </div>
           <div className='v-space-1'></div>
           <div style={ { color: letterColor } } className='jitsu-loading-span'>
             t
           </div>
         </div>
}


// WEBPACK FOOTER //
// ./src/Components/JitsuLoader/loading-v-text.js